<div class="row no-gutters">
  <div class="col-6 col-sm mobile-btn pr-1">
    <button
      type="button"
      class="btn btn-block"
      [ngClass]="{
        'btn-outline-danger': selectedValue === null || selectedValue === '',
        'btn-secondary': selectedValue === opt1.value,
        'btn-light': selectedValue === opt2.value
      }"
      (click)="optionSelected(opt1)"
    >{{ opt1.text }}</button>
  </div>
  <div class="col-6 col-sm mobile-btn pl-1">
    <button
      type="button"
      class="btn btn-block"
      [ngClass]="{
        'btn-outline-danger': selectedValue === null || selectedValue === '',
        'btn-secondary': selectedValue === opt2.value,
        'btn-light': selectedValue === opt1.value
      }"
      (click)="optionSelected(opt2)"
    >{{ opt2.text }}</button>
  </div>
</div>